<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
              class="d-flex justify-space-between justify-md-start"
            >
              <v-btn
                color="success"
                class="button-shadow"
                @click="Done"
              >
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="preview-page">
        <v-row class="preview-page">
          <v-col cols="12" lg="12" md="12" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <div>
                  <embed
                    v-bind:src="fileurl"
                    type="application/pdf"
                    width="100%"
                    height="1000"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
import { mapActions } from "vuex";
export default {
  name: "PrintPage",
  data() {
    return {
      fileurl: '',
      initvalue: null,
      params: null,
    };
  },
  methods: {
    ...mapActions("File", ["getDownloadFile"]),
    Done(){
      if(this.initvalue._isFrom!=null) this.$router.replace({ name: this.initvalue._isFrom, params: this.params });
      else if(this.initvalue.isFromBill)this.$router.push({ name: 'BillView', params: this.params });
      else if(this.initvalue.isFromBankAccount)this.$router.push({ name: 'BankAccountView', params: this.params });
      else if(this.initvalue.isFromClaim)this.$router.push({ name: 'ClaimView', params: this.params });
      else if(this.initvalue.isFromEmployee)this.$router.push({ name: 'EmployeeView', params: this.params });
      else if(this.initvalue.isFromInvoice)this.$router.push({ name: 'InvoiceView', params: this.params });
      else if(this.initvalue.isFromPayroll)this.$router.push({ name: 'PayrollView', params: this.params });
      else if(this.initvalue.isFromReimbursement)this.$router.push({ name: 'ReimbursementView', params: this.params });
      else if(this.initvalue.isFromSalesOrder)this.$router.push({ name: 'SalesOrderView', params: this.params });
      else this.$router.push({ name: 'Dashboard' });
    }
  },
  async created() {
    this.initvalue = this.$route.params;
    this.params = Object.assign({}, this.initvalue);
    let filesrc = await this.getDownloadFile(this.initvalue.fileurl);
    this.fileurl = filesrc;
  },
};
</script>

<style src="./Preview.scss" lang="scss" scoped />
